import React, { useEffect, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import { Link, useLocation } from "react-router-dom";
import { AiFillGithub } from "react-icons/ai";
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";
import { AiOutlineTrophy } from "react-icons/ai";

import { CgFileDocument } from "react-icons/cg";
import { AiOutlineMail } from "react-icons/ai";
import { AiOutlineRead } from "react-icons/ai";
import { FiImage } from "react-icons/fi";
import { FiBookOpen } from "react-icons/fi";

function NavBar() {
  const location = useLocation();
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  useEffect(() => {
    function handleScroll() {
      if (window.scrollY >= 20) {
        updateNavbar(true);
      } else {
        updateNavbar(false);
      }
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    // Initialize on mount
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const honorsPaths = ["/certificates", "/awards", "/volunteer"];
  const honorsActive = honorsPaths.includes(location.pathname);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" style={{ marginRight: "2rem", paddingLeft: "0" }}>
          <strong><span className="purple">UNAIS</span></strong>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          aria-label="Toggle navigation menu"
          aria-expanded={expand}
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav" style={{ transition: "all 0.3s ease" }}>
          <Nav className="mx-auto" defaultActiveKey="#home" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Nav.Item>
              <Nav.Link 
                as={Link} 
                to="/" 
                onClick={() => updateExpanded(false)}
                className={location.pathname === "/" ? "active-nav-link" : ""}
                style={{
                  color: location.pathname === "/" ? "var(--color-primary)" : "inherit",
                  fontWeight: location.pathname === "/" ? 600 : 400,
                }}
              >
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/about"
                onClick={() => updateExpanded(false)}
                className={location.pathname === "/about" ? "active-nav-link" : ""}
                style={{
                  color: location.pathname === "/about" ? "var(--color-primary)" : "inherit",
                  fontWeight: location.pathname === "/about" ? 600 : 400,
                }}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/project"
                onClick={() => updateExpanded(false)}
                className={location.pathname === "/project" ? "active-nav-link" : ""}
                style={{
                  color: location.pathname === "/project" ? "var(--color-primary)" : "inherit",
                  fontWeight: location.pathname === "/project" ? 600 : 400,
                }}
              >
                <AiOutlineFundProjectionScreen
                  style={{ marginBottom: "2px" }}
                />{" "}
                Projects
              </Nav.Link>
            </Nav.Item>
            <NavDropdown
              title={
                <span style={{ color: honorsActive ? "var(--color-primary)" : "inherit", fontWeight: honorsActive ? 600 : 400 }}>
                  <AiOutlineTrophy style={{ marginBottom: "2px" }} /> Honors &amp; Awards
                </span>
              }
              id="honors-nav-dropdown"
              className={honorsActive ? "active-nav-dropdown" : ""}
            >
              <NavDropdown.Item as={Link} to="/certificates" onClick={() => updateExpanded(false)}>
                Certificates
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/awards" onClick={() => updateExpanded(false)}>
                Awards
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/volunteer" onClick={() => updateExpanded(false)}>
                Volunteer
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/resume"
                onClick={() => updateExpanded(false)}
                className={location.pathname === "/resume" ? "active-nav-link" : ""}
                style={{
                  color: location.pathname === "/resume" ? "var(--color-primary)" : "inherit",
                  fontWeight: location.pathname === "/resume" ? 600 : 400,
                }}
              >
                <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/contact"
                onClick={() => updateExpanded(false)}
                className={location.pathname === "/contact" ? "active-nav-link" : ""}
                style={{
                  color: location.pathname === "/contact" ? "var(--color-primary)" : "inherit",
                  fontWeight: location.pathname === "/contact" ? 600 : 400,
                }}
              >
                <AiOutlineMail style={{ marginBottom: "2px" }} /> Contact
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/research"
                onClick={() => updateExpanded(false)}
                className={location.pathname === "/research" ? "active-nav-link" : ""}
                style={{
                  color: location.pathname === "/research" ? "var(--color-primary)" : "inherit",
                  fontWeight: location.pathname === "/research" ? 600 : 400,
                }}
              >
                <AiOutlineRead style={{ marginBottom: "2px" }} /> Research
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/gallery"
                onClick={() => updateExpanded(false)}
                className={location.pathname === "/gallery" ? "active-nav-link" : ""}
                style={{
                  color: location.pathname === "/gallery" ? "var(--color-primary)" : "inherit",
                  fontWeight: location.pathname === "/gallery" ? 600 : 400,
                }}
              >
                <FiImage style={{ marginBottom: "2px" }} /> Gallery
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/blog"
                onClick={() => updateExpanded(false)}
                className={location.pathname === "/blog" ? "active-nav-link" : ""}
                style={{
                  color: location.pathname === "/blog" ? "var(--color-primary)" : "inherit",
                  fontWeight: location.pathname === "/blog" ? 600 : 400,
                }}
              >
                <FiBookOpen style={{ marginBottom: "2px" }} /> Blog
              </Nav.Link>
            </Nav.Item>

            <Nav.Item style={{ marginLeft: "auto" }}>
              <Nav.Link 
                href="https://github.com/unaisshazan" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="GitHub"
                style={{
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "var(--color-primary)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "inherit";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <AiFillGithub style={{ marginBottom: "2px" }} /> GitHub
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
